import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import { noop } from '@ajaibid/utils';
import EmailPassword from '@assets/Image/svg/update-password/emailPassword';

import { PopUpCenterV2 } from 'Component/PopUp';
import { Text, Button } from 'Component/Ajaib';

const ModalVerification = (props) => {
  const { show, handleHideModal } = props;
  return (
    <PopUpCenterV2 
      title="Ubah Password" 
      show={show} 
      onHide={handleHideModal}
      closeButton={false}
      width="540px"
    >
      <Col md={12}>
        <Col md={12} className="p-0 d-flex justify-content-center">
          <EmailPassword />
        </Col>
        <Text className="mt-16">
          Kami telah mengirim tautan untuk mengubah password ke emailmu. 
          Periksa juga folder spam jika diperlukan.
        </Text>
      </Col>
      <Col md={12} className="p-0 mt-24 d-flex justify-items-center">
        <Button fluid variant="primary" onClick={handleHideModal} className="m-auto">
          Cek Email
        </Button>
      </Col>
    </PopUpCenterV2>
  );
};

ModalVerification.propTypes = {
  handleHideModal: PropTypes.func,
  show: PropTypes.bool,
};

ModalVerification.defaultProps = {
  handleHideModal: noop,
  show: false
};

export default ModalVerification;
